import { CardProps as CDSCardProps, Card as CDSCard } from "design-system/components/Card";
import { ReactNode } from "react";

interface DashboardCardProps extends Omit<CDSCardProps, "children"> {
  children: ReactNode;
}

export default function DashboardCard({ children, ...rest }: DashboardCardProps) {
  return (
    <CDSCard elevation="none" border={true} radius="medium" padding="medium" {...rest}>
      {children}
    </CDSCard>
  );
}
